import React, { useEffect, useState } from "react";
import {
  Form,
  Offcanvas,
  Button,
  Table,
  Tab,
  Tabs,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  DisplaySettingsOutlined,
  DragHandleOutlined,
  VisibilityOutlined,
  DeleteForeverOutlined,
  ArrowForwardIosOutlined,
  Star,
  OndemandVideo,
  Notes,
  ErrorOutline,
} from "@mui/icons-material";

import SidebarSlidesNews from "../../components/pgi/SidebarSlidesNews";
import useNews from "../../hooks/useNews";
import SidebarSlidesNewsEdit from "../../components/pgi/SidebarSlidesNewsEdit";
import TensoBlogReplicaPgi from "./editComponents/TensoBlogReplicaPgi";
import useHome from "../../hooks/useHome";
import usePgiModules from "../../hooks/useModules";
import toast from "react-hot-toast";
import useAudit from "../../hooks/useAudit";

const HomePgiNews = () => {
  const [showNewsHome, setShowNewsHome] = useState(true);
  const handleClose = () => setShowNewsHome(false);
  const handleShow = () => setShowNewsHome(true);
  const [selectBanner, setSelectBanner] = useState(false);
  const [modulesNew, setModulesNew] = useState(null);
  const [selectBloque, setSelectBloque] = useState(false);
  const { banners, handleVisibilityBanners, bloques, handleVisibilityBloque } =
    useHome();
  const { createAuditRequest } = useAudit();
  const {
    modules,
    setModules,
    getModulesByParams,
    handleVisibility,
    handleModuleUpdate,
  } = usePgiModules();
  const {
    obtenerNoticias,
    news,
    handleVisibilityNews,
    handleNewsUpdate,
    handleVisibilitySlide,
  } = useNews();

  const user = JSON.parse(localStorage.getItem("Usuario"))?.UserLogin?.name;

  const arrayBanner = banners?.find((banner) => banner.state === true);
  useEffect(() => {
    obtenerNoticias();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    getModulesByParams({ state: true }).then((res) => {
      setModules(res.sort((a, b) => a.position - b.position));
    });
    document.title = "Personalizar TensoNews | PGI Tensolite"; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setModulesNew(
      modules?.filter(
        (module) =>
          module?.title === "Carrousel_deLinea" ||
          module?.title === "Carrousel_especial" ||
          module?.title === "Banner_publicitario" ||
          module?.title === "Bloque_info"
      )
    );
  }, [modules]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // eliminarNoticia(editNews);
    // console.log(editNews);
  };

  const handleDelete = (id) => {
    const toastId = toast(
      <div className="flex-column">
        <div className="text-center error_icon">
          <ErrorOutline />
        </div>
        <div className="text-center my-2">
          ¿Estas seguro de eliminar esta noticia?
        </div>
        <div className="d-flex justify-content-around">
          <Button
            className="w-40 button_error"
            variant="danger"
            onClick={() => handleConfirmDelete(id, "DELETE")}
          >
            Si
          </Button>
          <Button
            className="w-40 button_error"
            variant="secondary"
            onClick={() => toast.dismiss(toastId)}
          >
            No
          </Button>
        </div>
      </div>,
      {
        duration: 20000,
      }
    );
  };

  const handleConfirmDelete = (id, action) => {
    const newDelete = news?.find((noticia) => noticia._id === id && noticia);
    createAuditRequest(
      {
        ...newDelete,
        element: 1,
        deleted: true,
        creator: user,
        imageCover: [],
        imageCover_tablet: [],
        imageCover_mobile: [],
      },
      "DELETE"
    );
    toast.dismiss();
  };

  const slideNoticiasNew = news?.filter(
    (noticia) =>
      noticia.slideNews === true &&
      noticia.deleted === false &&
      noticia.visible === true
  );
  const noticiasTable = news?.filter(
    (noticia) => !noticia.deleted && noticia.publish === true
  );

  return (
    <div id="wrapperEditNews" className="wrapperPgi">
      <button onClick={handleShow} className="basePgi__setttings-button">
        <DisplaySettingsOutlined />
      </button>
      <div className="card container containerPgi">
        <TensoBlogReplicaPgi />
      </div>

      {/* OFFCANVAS SETTING HOME*/}
      <Offcanvas
        show={showNewsHome}
        onHide={handleClose}
        placement="start"
        scroll
        enforceFocus
        backdrop={false}
        className="basePgi__pgi"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>TensoBlog</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Tabs
            defaultActiveKey="slide"
            active
            id="productos-tab"
            className="pgi__productos-tab"
          >
            <Tab eventKey="slide" title="Noticias">
              <form
                id="formEditarHSlider"
                className="basePgi__vista-edit-gral"
                onSubmit={handleSubmit}
              >
                <header aria-labelledby="formEditarHSlider">
                  <h2>Slide Noticias</h2>
                </header>
                <Table responsive className="basePgi__table-list" hover>
                  <colgroup>
                    <col span="1" className="basePgi__table-col-min" />
                    <col span="1" className="basePgi__table-col-position" />
                    <col span="2" className="basePgi__table-col-max" />
                  </colgroup>
                  <tbody>
                    {slideNoticiasNew.map(
                      (noticia, index) =>
                        noticia.slideNews === true &&
                        noticia.deleted === false &&
                        noticia.visible === true && (
                          <>
                            <tr key={noticia._id}>
                              <td></td>
                              <td>{index + 1}</td>
                              <td>{noticia.title}</td>
                              <td
                                onClick={() =>
                                  handleVisibilitySlide(noticia._id)
                                }
                              >
                                <OverlayTrigger
                                  key="1"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="1">Mostrar en slide</Tooltip>
                                  }
                                >
                                  <Button
                                    className={
                                      noticia.slideNews ? "" : "disabled"
                                    }
                                  >
                                    {" "}
                                    <Star
                                      className={`${
                                        noticia.slideNews ? "bg-star" : ""
                                      }`}
                                    />{" "}
                                  </Button>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          </>
                        )
                    )}

                    {/*************** end solo maqueta ************************* */}
                  </tbody>
                </Table>
              </form>
            </Tab>
            <Tab eventKey="modulos" title="Módulos">
              <form
                id="formEditarHModulos"
                className="basePgi__vista-edit-gral"
              >
                <header aria-labelledby="formEditarHModulos">
                  <h2>Módulos</h2>
                </header>
                <Table responsive className="basePgi__table-list" hover>
                  <colgroup>
                    <col span="1" className="basePgi__table-col-min" />
                    <col span="1" className="basePgi__table-col-position" />
                    <col span="1" className="basePgi__table-col-max" />
                    <col span="1" className="basePgi__table-col-min" />
                    <col span="1" className="basePgi__table-col-max" />
                    <col span="2" className="basePgi__table-col-min" />
                  </colgroup>
                  <tbody>
                    {
                      // mapeo automatico de tabla de modulos
                      modulesNew?.map((module, index) => {
                        return (
                          module.title !== "TensoNews" && (
                            <>
                              <tr key={index}>
                                <td>
                                  <Button disabled>
                                    <DragHandleOutlined />
                                  </Button>
                                </td>
                                <td className="pgi__table-position-number">
                                  <b></b>
                                </td>
                                <td className="pgi__module-name">
                                  {module.title}
                                </td>
                                <td>{module.moduleType}</td>
                                {module.title === "Banner_publicitario" ? (
                                  <td>
                                    {arrayBanner?.title
                                      ? arrayBanner?.title
                                      : ""}
                                  </td>
                                ) : (
                                  <td>
                                    {module?.content
                                      ? module.content[index]
                                      : ""}
                                  </td>
                                )}

                                <td>
                                  <OverlayTrigger
                                    key="1"
                                    placement="top"
                                    overlay={
                                      <Tooltip id="1">Visibilidad</Tooltip>
                                    }
                                  >
                                    <Button
                                      className={
                                        module.visible.find(
                                          (item) => item === "news"
                                        )
                                          ? ""
                                          : "disabled"
                                      }
                                      onClick={() =>
                                        handleVisibility(module, "news")
                                      }
                                    >
                                      <VisibilityOutlined />
                                    </Button>
                                  </OverlayTrigger>
                                </td>
                                {module.editable ? (
                                  <td>
                                    {/* <Button><ModeEditOutlined/></Button> */}
                                    {module.title === "Banner_publicitario" && (
                                      <OverlayTrigger
                                        key="1"
                                        placement="top"
                                        overlay={
                                          <Tooltip id="1">Ver banners</Tooltip>
                                        }
                                      >
                                        <Button
                                          onClick={() =>
                                            setSelectBanner(!selectBanner)
                                          }
                                        >
                                          <ArrowForwardIosOutlined />
                                        </Button>
                                      </OverlayTrigger>
                                    )}
                                    {module.title === "Bloque_info" && (
                                      <OverlayTrigger
                                        key="1"
                                        placement="top"
                                        overlay={
                                          <Tooltip id="1">Ver Bloques</Tooltip>
                                        }
                                      >
                                        <Button
                                          onClick={() =>
                                            setSelectBloque(!selectBloque)
                                          }
                                        >
                                          <ArrowForwardIosOutlined />
                                        </Button>
                                      </OverlayTrigger>
                                    )}
                                  </td>
                                ) : (
                                  <td></td>
                                )}
                              </tr>
                            </>
                          )
                        );
                      })
                    }
                  </tbody>
                </Table>
                <button
                  type="button"
                  className="settings_button-pleno"
                  onClick={handleModuleUpdate}
                >
                  Actualizar Módulos
                </button>
              </form>
            </Tab>
          </Tabs>

          {selectBanner === true && (
            <>
              <hr className="basePgi__space-line" />
              <form
                action=""
                id="formEditarHModulos"
                className="basePgi__vista-edit-gral"
              >
                <header aria-labelledby="formEditarHModulos">
                  <h2>Selecciona los banners</h2>
                </header>
                <Table responsive className="basePgi__table-list" hover>
                  <colgroup>
                    <col span="1" className="basePgi__table-col-min" />
                    <col span="1" className="basePgi__table-col-max" />
                    <col span="2" className="basePgi__table-col-min" />
                  </colgroup>
                  <tbody>
                    {banners?.map(
                      (banner) =>
                        banner?.deleted === false && (
                          <>
                            <tr key={banner._id}>
                              <td className="pgi__table-check">
                                <Form.Check
                                  inline
                                  aria-label="banner #id" // indicar x variable el nº id
                                  name="selectBanner"
                                  type="checkbox"
                                  id="align-left"
                                  defaultChecked={banner.section.find(
                                    (item) => item === "news"
                                  )}
                                  onClick={() => {
                                    handleVisibilityBanners(banner._id, "news");
                                  }}
                                />
                              </td>
                              <td>{banner.title}</td>
                            </tr>
                          </>
                        )
                    )}
                  </tbody>
                </Table>
              </form>
            </>
          )}
          {selectBloque === true && (
            <>
              <hr className="basePgi__space-line" />
              <form
                action=""
                id="formEditarHModulos"
                className="basePgi__vista-edit-gral"
              >
                <header aria-labelledby="formEditarHModulos">
                  <h2>Selecciona los bloques de info</h2>
                </header>
                <Table responsive className="basePgi__table-list" hover>
                  <colgroup>
                    <col span="1" className="basePgi__table-col-min" />
                    <col span="1" className="basePgi__table-col-max" />
                    <col span="2" className="basePgi__table-col-min" />
                  </colgroup>
                  <tbody>
                    {bloques?.map(
                      (bloque) =>
                        bloque?.deleted === false && (
                          <>
                            <tr key={bloque._id}>
                              <td className="pgi__table-check">
                                <Form.Check
                                  inline
                                  aria-label="banner #id" // indicar x variable el nº id
                                  name="selectBanner"
                                  type="checkbox"
                                  id="align-left"
                                  defaultChecked={bloque.visible.find(
                                    (item) => item === "news"
                                  )}
                                  onClick={() => {
                                    handleVisibilityBloque(bloque._id, "news");
                                  }}
                                />
                              </td>
                              <td>{bloque.title_content}</td>
                            </tr>
                          </>
                        )
                    )}
                  </tbody>
                </Table>
              </form>
            </>
          )}
          <hr className="basePgi__space-line" />
          <form id="formEditarHSlider" className="basePgi__vista-edit-gral">
            {/* NOTICIAS */}

            <header aria-labelledby="formEditarHSlider">
              <h2>Noticias</h2>
              <SidebarSlidesNews />
            </header>
            <Table responsive className="basePgi__table-list" hover>
              <colgroup>
                <col span="1" className="basePgi__table-col-min" />
                <col span="1" className="basePgi__table-col-max" />
                <col span="4" className="basePgi__table-col-min" />
              </colgroup>
              <tbody>
                {noticiasTable.map(
                  (noticia, index) =>
                    !noticia.deleted &&
                    noticia.publish === true && (
                      <tr key={noticia._id}>
                        <td>
                          {noticia.multimedia ? <OndemandVideo /> : <Notes />}
                        </td>

                        <td>{noticia.title}</td>
                        <td onClick={() => handleVisibilitySlide(noticia._id)}>
                          <OverlayTrigger
                            key="1"
                            placement="top"
                            overlay={<Tooltip id="1">Mostrar en slide</Tooltip>}
                          >
                            <Button
                              className={noticia.slideNews ? "" : "disabled"}
                            >
                              {" "}
                              <Star
                                className={`${
                                  noticia.slideNews ? "bg-star" : ""
                                }`}
                              />{" "}
                            </Button>
                          </OverlayTrigger>
                        </td>
                        <td onClick={() => handleVisibilityNews(noticia._id)}>
                          <OverlayTrigger
                            key="1"
                            placement="top"
                            overlay={<Tooltip id="1">Visibilidad</Tooltip>}
                          >
                            <Button
                              className={noticia.visible ? "" : "disabled"}
                            >
                              {" "}
                              <VisibilityOutlined />{" "}
                            </Button>
                          </OverlayTrigger>
                        </td>
                        <td>
                          <Button>
                            <SidebarSlidesNewsEdit
                              key={noticia._id}
                              noticia={noticia}
                            />
                          </Button>
                        </td>
                        <td onClick={() => handleDelete(noticia._id)}>
                          {/* acción--> ELIMINA PUBLICACIÓN */}
                          <OverlayTrigger
                            key="1"
                            placement="top"
                            overlay={<Tooltip id="1">Eliminar</Tooltip>}
                          >
                            <Button>
                              <DeleteForeverOutlined />
                            </Button>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    )
                )}
              </tbody>
            </Table>
            <button
              type="button"
              className="settings_button-pleno"
              onClick={handleNewsUpdate}
            >
              Guardar cambios
            </button>
          </form>

          {/****************end form módulos *************************** */}
        </Offcanvas.Body>
      </Offcanvas>
      {/*offC slides */}
    </div>
  );
};

export default HomePgiNews;
